let map = null;
let points = [];
let markers = [];
let activeIndex = -1;
let linkEl = null;

const MAP_STYLES = [
    {"elementType":"geometry","stylers":[{"color":"#212121"}]},
    {"elementType":"labels.icon","stylers":[{"visibility":"off"}]},
    {"elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},
    {"elementType":"labels.text.stroke","stylers":[{"color":"#212121"}]},
    {"featureType":"administrative","elementType":"geometry","stylers":[{"color":"#757575"}]},
    {"featureType":"administrative.country","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]},
    {"featureType":"administrative.land_parcel","stylers":[{"visibility":"off"}]},
    {"featureType":"administrative.locality","elementType":"labels.text.fill","stylers":[{"color":"#bdbdbd"}]},
    {"featureType":"landscape.natural","elementType":"geometry.fill","stylers":[{"color":"#06140d"}]},
    {"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]}, /* ← было без # */
    {"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#181818"}]},
    {"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},
    {"featureType":"poi.park","elementType":"labels.text.stroke","stylers":[{"color":"#1b1b1b"}]},
    {"featureType":"road","elementType":"geometry.fill","stylers":[{"color":"#2c2c2c"}]},
    {"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#8a8a8a"}]},
    {"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#373737"}]},
    {"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#3c3c3c"}]},
    {"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#4b4e41"}]},
    {"featureType":"road.highway.controlled_access","elementType":"geometry","stylers":[{"color":"#4e4e4e"}]},
    {"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},
    {"featureType":"transit","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},
    {"featureType":"water","stylers":[{"color":"#353cfd"},{"visibility":"on"},{"weight":6}]},
    {"featureType":"water","elementType":"geometry","stylers":[{"color":"#000000"}]},
    {"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#353cfd"},{"visibility":"on"}]},
    {"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#3d3d3d"}]}
];


function buildMapLink(p) {
    const hasLL = p.lat != null && p.lng != null;
    const z = Number(p.zoom) || 14;

    if (p.place_id && p.address) {
        return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(p.address)}&query_place_id=${encodeURIComponent(p.place_id)}`;
    }

    if (p.place_id) {
        return `https://www.google.com/maps/place/?q=place_id:${encodeURIComponent(p.place_id)}`;
    }

    if (p.address) {
        return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(p.address)}`;
    }

    if (hasLL) {
        return `https://www.google.com/maps/@?api=1&map_action=map&center=${p.lat},${p.lng}&zoom=${z}`;
    }
    return '#';
}

export function updateMap(idx) {
    if (!map || !Array.isArray(points) || !points[idx] || !markers[idx]) return;
    if (idx === activeIndex) return;

    if (activeIndex >= 0 && markers[activeIndex]) {
        markers[activeIndex].setVisible(false);
    }

    const p = points[idx];
    const m = markers[idx];
    m.setVisible(true);

    const targetZoom = p.zoom ? Number(p.zoom) : map.getZoom();
    if (typeof targetZoom === 'number' && targetZoom !== map.getZoom()) {
        map.setZoom(targetZoom);
    }

    const pos = m.getPosition();
    map.setCenter(pos);

    if (linkEl) {
        const href = buildMapLink(p);
        linkEl.setAttribute('href', href);
        linkEl.setAttribute('rel', 'noopener noreferrer');
        linkEl.setAttribute('target', '_blank');
    }

    activeIndex = idx;
}

export function initMap() {
    const wrap = document.querySelector('.contacts-section__map');
    if (!wrap) return;

    linkEl = document.querySelector('[data-map-link]') || null;

    try {
        points = JSON.parse(wrap.getAttribute('data-map')) || [];
    } catch {
        points = [];
    }
    if (!points.length) return;

    const canvas = document.getElementById('contactsMapCanvas');
    if (!canvas) return;

    const first = points[0] || {};
    if (first.lat == null || first.lng == null) return;

    const center = { lat: Number(first.lat), lng: Number(first.lng) };

    map = new google.maps.Map(canvas, {
        center,
        zoom: first.zoom ? Number(first.zoom) : 14,
        styles: MAP_STYLES,
        disableDefaultUI: true,
        gestureHandling: 'cooperative'
    });

    const iconUrl = `${ajax_params.theme_url}/assets/img/sprite/marker.svg`;
    const baseIcon = {
        url: iconUrl,
        scaledSize: new google.maps.Size(40, 59),
        anchor: new google.maps.Point(20, 58)
    };

    markers = points.map((p) => {
        const pos = { lat: Number(p.lat), lng: Number(p.lng) };
        const m = new google.maps.Marker({
            position: pos,
            map: map,
            icon: baseIcon,
            optimized: true,
            visible: false
        });
        return m;
    });

    activeIndex = -1;
    updateMap(0);

    window.addEventListener('resize', () => {
        if (activeIndex >= 0 && markers[activeIndex]) {
            map.setCenter(markers[activeIndex].getPosition());
        }
    });
}

document.addEventListener('DOMContentLoaded', () => {
    const { google_api_key } = window.ajax_params || {};
    if (!google_api_key) {
        console.error('google_api_key not found');
        return;
    }

    const s = document.createElement('script');
    s.src = `https://maps.googleapis.com/maps/api/js?key=${google_api_key}&v=weekly&callback=initContactsMap`;
    s.async = true;
    s.defer = true;
    document.head.appendChild(s);

    window.initContactsMap = initMap;
});
